import {changeRef,stringify} from '@/common/common'

const sessioncache = {
  get: function(key) {
    return changeRef(JSON.parse(sessionStorage.getItem(key)))
  },
  set: function(key, value) {
    if (value) {
      sessionStorage.setItem(key, stringify(value,[]))
    } else {
      sessionStorage.removeItem(key)
    }
  },
  remove: function(key) {
    sessionStorage.removeItem(key)
  }
}

export default sessioncache



// WEBPACK FOOTER //
// ./src/common/sessioncache.js